import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { getIdSafeString } from '@/utils/formatting/strings';

export interface EstateOnboardingSuggestionMenuItemProps {
  label: React.ReactNode;
  count: number;
  onClick: () => void;
}

export function EstateOnboardingSuggestionMenuItem({
  label,
  count,
  onClick,
}: EstateOnboardingSuggestionMenuItemProps) {
  const testId = `estate-suggestion-menu-item-${getIdSafeString(String(label))}`;

  return (
    <MenuItem
      dataTestId={testId}
      label={label}
      justifyContent="space-between"
      iconAfter={
        <Badge
          variant={BadgeVariants.Success}
          display={count}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '24px',
          }}
        />
      }
      onClick={onClick}
    />
  );
}
